import { useMemo } from 'react';
import { useUserProducts } from '@/hooks/useUserProducts';
import pages, { Page, PageNames } from '@/features/lobby/components/Header/HeaderLinks/headerLinksList';

export const useHeaderLinks = (): { pages: Page[] } => {
  const { adminProducts } = useUserProducts();

  const availablePages = useMemo(() => {
    if (!adminProducts || adminProducts.length === 0) {
      return pages.filter((page: Page) => page.linkName !== PageNames.Products);
    }
    return pages;
  }, [adminProducts]);

  return { pages: availablePages };
};
